import React from "react";
import { Link } from "react-router-dom";
import Collapsible from "react-collapsible";
import logo from "../assets/img/logo-buy-power.png";
import instagram from "../assets/img/instagram.svg";
import youtube from "../assets/img/youtube.svg";
import twitter from "../assets/img/twitter.svg";
import facebook from "../assets/img/facebooksc.svg";
import Path from "../assets/img/Path.svg";

export function NonAuthedFooter() {
  return (
    <div id="footer">
      <footer id="footer">
        <div className="footer__mobile">
          <div>
            <img src={logo} alt="buypower logo" />
            <div>
              ©{new Date().getFullYear()} BuyPower Inc. Datapex Drifty
              <br /> Technologies. All Rights Reserved.
            </div>
            <div className="footer__social">
              <a href="https://www.youtube.com/@buypower9962" target="_blank" rel="noopener noreferrer">
                <img src={youtube} alt="youtube" />
              </a>
              <a href="https://www.instagram.com/buypower.ng" target="_blank" rel="noopener noreferrer">
                <img src={instagram} alt="instagram" />
              </a>
              <a href="https://twitter.com/buypower_ng" target="_blank" rel="noopener noreferrer">
                <img src={twitter} alt="twitter" />
              </a>
              <a href="https://web.facebook.com/buyelectricity" target="_blank" rel="noopener noreferrer">
                <img src={facebook} alt="facebook" />
              </a>
            </div>
          </div>
          <div>
            <Collapsible
              trigger={
                <div className="collpase__trigger">
                  Products
                  <img src={Path} alt="toggle" />
                </div>
              }
            >
              <span>
                <Link to="/order/create">Pay Bills</Link>
              </span>
              <span>
                Buypower for Business <sub>coming soon</sub>
              </span>
              <span>
                <Link to="/order/create?product=data">Data Bundle</Link>
              </span>
              <span>
                <Link to="/order/create?product=airtime">Airtime</Link>
              </span>
              <span>
                <Link to="/order/create?product=cable">TV</Link>
              </span>
            </Collapsible>
            <Collapsible
              trigger={
                <div className="collpase__trigger">
                  Legal
                  <img src={Path} alt="toggle" />
                </div>
              }
            >
              <span>
                <Link to="/terms-of-use">Terms of Use</Link>
              </span>
              <span>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </span>
            </Collapsible>
            <Collapsible
              trigger={
                <div className="collpase__trigger">
                  Learn
                  <img src={Path} alt="toggle" />
                </div>
              }
            >
              <span>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://techcrunch.com/2017/03/16/buypower-aims-to-ease-the-pain-of-utility-payments-in-nigeria/"
                >
                  Press
                </a>
              </span>
              <span>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://blog.buypower.ng"
                >
                  Blog
                </a>
              </span>
              <span>
                <Link to="/faq">FAQ</Link>
              </span>
            </Collapsible>
            <Collapsible
              trigger={
                <div className="collpase__trigger">
                  Company
                  <img src={Path} alt="toggle" />
                </div>
              }
            >
              <span>
                <a href="https://conversations.buypower.ng/">Contact Us</a>
              </span>
              <span>
                <Link to="/about">About</Link>
              </span>
            </Collapsible>
          </div>
        </div>
        <div className="contain">
          <div className="footer__container">
            <div>
              <img src={logo} alt="buypower logo" />
              <div className="footercopyright">
                ©{new Date().getFullYear()} BuyPower Inc. Datapex Drifty
                <br /> Technologies. All Rights Reserved.
              </div>
              <div className="footer__social">
                <a href="https://www.youtube.com/@buypower9962" target="_blank" rel="noopener noreferrer">
                  <img src={youtube} alt="youtube" />
                </a>
                <a href="https://www.instagram.com/buypower.ng" target="_blank" rel="noopener noreferrer">
                  <img src={instagram} alt="instagram" />
                </a>
                <a href="https://twitter.com/buypower_ng" target="_blank" rel="noopener noreferrer">
                  <img src={twitter} alt="twitter" />
                </a>
                <a href="https://web.facebook.com/buyelectricity" target="_blank" rel="noopener noreferrer">
                  <img src={facebook} alt="facebook" />
                </a>
              </div>
              
            </div>
            <div>
              <h4>Products</h4>
              <span>
                <Link to="/order/create">Pay Bills</Link>
              </span>
              <span>
                Buypower for Business <sub>coming soon</sub>
              </span>
              <span>
                <Link to="/order/create?product=data">Data Bundle</Link>
              </span>
              <span>
                <Link to="/order/create?product=airtime">Airtime</Link>
              </span>
              <span>
                <Link to="/order/create?product=cable">TV</Link>
              </span>
            </div>
            <div>
              <h4>Legal</h4>
              <span>
                <Link to="/terms-of-use">Terms of Use</Link>
              </span>
              <span>
                <Link to="/privacy-policy">Privacy Policy</Link>
              </span>
            </div>
            <div>
              <h4>Learn</h4>
              <span>
                <span>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://techcrunch.com/2017/03/16/buypower-aims-to-ease-the-pain-of-utility-payments-in-nigeria/"
                  >
                    Press
                  </a>
                </span>
              </span>
              <span>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://blog.buypower.ng"
                >
                  Blog
                </a>
              </span>
              <span>
                <Link to="/faq">FAQ</Link>
              </span>
            </div>
            <div>
              <h4>Company</h4>
              <span>
                <a href="https://conversations.buypower.ng/">Contact Us</a>
              </span>
              <span>
              <Link to="/media-kit">Media Kit</Link>
              </span>
              <span>
                <Link to="/about">About</Link>
              </span>
            </div>
          </div>
        </div>
        {/* Add version date to footer (hidden) */}
        <div className="version-text">{process.env.REACT_APP_VERSION_TIME}</div>
      </footer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/NonAuthedFooter.js